import { useState, useEffect } from "react";

import { Card } from "react-bootstrap";
import Pulse from "react-reveal/Pulse";

import { colors, styleScreenDashboard } from "../../styles/style";

import SectionDelivery from "../sectionDelivery/sectionDelivery";
import ModalProds from "../modals/modalProds";
import ButtonCustom from "../buttons/buttonCustom";
import Separator from "../separator/separator";
import { BsFillCreditCardFill, BsCashCoin } from "react-icons/bs";

/**
 * @param {Object} order Objeto con la información de la orden
 * @param {Function} selectOrder Function to select order
 * @param {Function} createOrder Function to create order
 * @returns Tarjeta de la orden
 */
const CardOrder = ({ order, selectOrder, createOrder, cancelAction }) => {
  //console.log("🚀 ~ file: cardOrder.js:21 ~ CardOrder ~ order:", order)
  const [show, setShow] = useState(false);
  const [addressTo, setAddressTo] = useState("");
  const [addressFrom, setAddressFrom] = useState("");
  const [vehicle, setVehicle] = useState("");
  //? date of the order
  const [date, setDate] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    asignmentAddress();
    getSelectedVehicle();
    getDateOrder();
  }, []);

  const asignmentAddress = () => {
    if (
      order.shop_comments === "WISHES" ||
      order.shop_comments === "SOLUTIONS"
    ) {
      var addresses = [];
      addresses = JSON.parse(JSON.parse(order?.address)) ?? [0].name;

      setAddressFrom(addresses[0]);
      setAddressTo(addresses[1]);
    } else {
      setAddressFrom({ name: order.shop_id.address_shop });
      setAddressTo({ name: order.address });
    }
  };

  const getSelectedVehicle = () => {
    if (order.shipping_fees) {
      let fees = JSON.parse(order.shipping_fees);
      setVehicle(getValueByVehicle(fees.vehicle));
    }
  };

  function getValueByVehicle(value) {
    const types = {
      c: "Auto",
      m: "Motocicleta",
      b: "Bicicleta",
      Auto: "c",
      Motocicleta: "m",
      Bicicleta: "b",
    };

    return types[value] || "Motocicleta";
  }
  /**
   * Function to validate the order
   * @returns Boolean response if order is or not available
   */
  function validOrder() {
    if (order.level === "EN PROCESO") {
      return true;
    } else {
      return false;
    }
  }

  function showTravel() {
    var nameFrom = "";
    var nameTo = "";
    if (
      order.shop_comments === "WISHES" ||
      order.shop_comments === "SOLUTIONS"
    ) {
      //? coordenadas de las direcciones
      var coordsFrom = addressFrom?.coords;
      var coordsTo = addressTo?.coords;
      //? nombre de las direcciones
      nameFrom = addressFrom?.name;
      nameTo = addressTo?.name;

      if (coordsFrom.lenght > 0) {
        window.open(
          `https://www.google.com.mx/maps/dir/${coordsFrom}/${coordsTo}`,
          "_blank"
        );
      } else {
        window.open(
          `https://www.google.com.mx/maps/dir/${nameFrom}/${nameTo}`,
          "_blank"
        );
      }
    } else {
      nameFrom = order.address;
      nameTo = order.shop_id.address_shop;

      window.open(
        `https://www.google.com.mx/maps/dir/${nameFrom}/${nameTo}`,
        "_blank"
      );
    }
  }

  /**
   * Function to get the date of the order
   */
  function getDateOrder() {
    let historyBD = JSON.parse(order.history);

    if (typeof historyBD !== "object") historyBD = JSON.parse(historyBD);
    if (typeof historyBD === "object") {
      let found = historyBD.findIndex(
        (element) =>
          element.level === "EN PROCESO" && element.status === "LISTO"
      );
      //? found last date of update in order
      if (found > -1) {
        let dateOrder =
          historyBD[found].hour.substring(0, 10) +
          ", " +
          historyBD[found].hour.substring(11, 16);

        setDate(dateOrder);
      }
    }
  }

  return (
    !!validOrder() && (
      <div>
        <ModalProds
          title={"Productos"}
          products={order.products.items}
          show={show}
          handleClose={handleClose}
          specialOrder={
            order.shop_comments === "WISHES"
              ? "WISHES"
              : order.shop_comments === "SOLUTIONS"
              ? "SOLUTIONS"
              : "NA"
          }
        />
        <Pulse>
          <div style={styleScreenDashboard.cardColumn}>
            <Card style={styleScreenDashboard.borderCards}>
              <Card.Body>
                <Card.Title>
                  <div className="row">
                    <Card.Text className="col-8">
                      #{order.id.substring(0, 6)}
                      {order.shop_comments === "WISHES"
                        ? " | Niku deseo"
                        : order.shop_comments === "SOLUTIONS"
                        ? " | Niku mandado"
                        : " | " +
                          order.shop_id.shop_name +
                          (order.shop_id.acceptCard ? "" : " (sólo efectivo)")}
                    </Card.Text>
                    <div
                      style={{ flex: 1, paddingLeft: "8%" }}
                      className="col fs-6"
                    >
                      <Card.Text>{date}</Card.Text>
                    </div>
                  </div>
                </Card.Title>
                <Separator />
                <div className="row">
                  <Card.Text className="col-9 fs-5">
                    Cliente:{" "}
                    {order.customer_id.name + " " + order.customer_id.last_name}
                  </Card.Text>
                  <Card.Text
                    className="col fs-6"
                    style={{ alignSelf: "center" }}
                  >
                    {order.method_pay !== "EFECTIVO" ? (
                      <div className="row">
                        <p className="col">Tarjeta</p>
                        <BsFillCreditCardFill
                          className="col"
                          size={25}
                          color={colors.GREEN_2_COLOR}
                        />
                      </div>
                    ) : (
                      <div className="row">
                        <p className="col">Efectivo</p>
                        <BsCashCoin
                          className="col"
                          size={25}
                          color={colors.GREEN_2_COLOR}
                        />
                      </div>
                    )}
                  </Card.Text>
                </div>
                <div className="row">
                  <div className="col-9">
                    <Card.Text>Trayecto</Card.Text>
                    <Card.Text>Desde: {addressFrom.name}</Card.Text>
                    <Card.Text>Hasta: {addressTo.name}</Card.Text>
                  </div>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <ButtonCustom
                      text={"Ver trayecto"}
                      type={"blue"}
                      functionBtn={showTravel}
                    />
                  </div>
                </div>
                <Separator />
                <div className={"row align-items-center"}>
                  <div className={"col-9"}>
                    <Card.Text>Productos</Card.Text>
                  </div>
                  <div className={"col"} style={{ alignSelf: "center" }}>
                    <ButtonCustom
                      text={"Ver productos"}
                      type={"blue"}
                      functionBtn={handleShow}
                    />
                  </div>
                </div>
                <div class="row align-items-center">
                  <Card.Text class="col-6 col-md-8">
                    Vehículo solicitado
                  </Card.Text>
                  <Card.Text
                    class="col-12 col-md-4"
                    style={{
                      alignSelf: "center",
                      textAlign: "end",
                      paddingRight: "3.5%",
                      fontSize: 18,
                      fontWeight: "700",
                      color: colors.ORANGE_COLOR,
                    }}
                  >
                    {vehicle}
                  </Card.Text>
                </div>
                <SectionDelivery
                  order={order}
                  selectOrder={selectOrder}
                  createOrder={createOrder}
                  abortAction={cancelAction}
                  vehicle={vehicle}
                />
              </Card.Body>
            </Card>
          </div>
        </Pulse>
      </div>
    )
  );
};

export default CardOrder;
